import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Notes from "./pages/Notes";
import Works from "./pages/Works";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WorkDetail from "./pages/WorkDetail";
import Creatives from "./pages/services/Creatives";
import Brands from "./pages/services/Brands";
import Studios from "./pages/services/Studios";
import Supports from "./pages/services/Supports";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/works" element={<Works />} />
        <Route path="/works/:id" element={<WorkDetail />} />
        <Route path="/services/creatives" element={<Creatives />} />
        <Route path="/services/brands" element={<Brands />} />
        <Route path="/services/studios" element={<Studios />} />
        <Route path="/services/supports" element={<Supports />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;